export default __webpack_public_path__ + "static/media/T124_T240_T340_T344_T346_T750_T760_T860_28AXXXA_GENERIC_SILVER.80efabab.STEP";